// extracted by mini-css-extract-plugin
export default {"swatch":"InlineColorPicker_swatch__SI6Sd","color":"InlineColorPicker_color__opSt9","popover":"InlineColorPicker_popover__Ugn15","cover":"InlineColorPicker_cover__S0Cit"};